webpackJsonp([1],{

/***/ "+R46":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jmt5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/dist/bootstrap-vue.esm.js
var bootstrap_vue_esm = __webpack_require__("sCSS");

// EXTERNAL MODULE: ./node_modules/bootstrap/dist/css/bootstrap.css
var bootstrap = __webpack_require__("Jmt5");
var bootstrap_default = /*#__PURE__*/__webpack_require__.n(bootstrap);

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/dist/bootstrap-vue.css
var bootstrap_vue = __webpack_require__("9M+g");
var bootstrap_vue_default = /*#__PURE__*/__webpack_require__.n(bootstrap_vue);

// EXTERNAL MODULE: ./node_modules/path.join/index.js
var path_join = __webpack_require__("TPi/");
var path_join_default = /*#__PURE__*/__webpack_require__.n(path_join);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/store/dist/store.legacy.js
var store_legacy = __webpack_require__("Y4FN");
var store_legacy_default = /*#__PURE__*/__webpack_require__.n(store_legacy);

// CONCATENATED MODULE: ./src/config.js
/* harmony default export */ var config = ({
  authUrl: 'http://ec2-54-218-51-130.us-west-2.compute.amazonaws.com/api/authenticate/github', // 'https://aqueous-reef-70776.herokuapp.com/authenticate/',
  clientId: '2f0bef2b6cc228ff321b',
  redirectUri: 'data.afqvault.org/',
  tables: ['projects', 'subjects'],
  url: 'http://ec2-54-218-51-130.us-west-2.compute.amazonaws.com/api/v1/', // 'http://localhost/api/v1',
  delete_url: 'http://ec2-54-218-51-130.us-west-2.compute.amazonaws.com/api/delete_project/',
  projects: {
    sha: {
      type: 'string'
    },
    url: {
      type: 'string'
    },
    scan_parameters: {
      type: 'dict'
    },
    delete: {
      type: 'button',
      action: 'delete'
    }
  },
  subjects: {
    subjectID: {
      type: 'string'
    },
    sessionID: {
      type: 'string'
    },
    metadata: {
      type: 'dict'
    },
    nodes: {
      type: 'list-dict'
    },
    project_id: {
      type: 'objectid',
      relation: 'projects'
    }
  }
});
// CONCATENATED MODULE: ./src/lib/auth.js





window.axios = axios_default.a;
window.store = store_legacy_default.a;
// CREDITS: http://www.gethugames.in/2012/04/authentication-and-authorization-for-google-apis-in-javascript-popup-window-tutorial.html
// credits: http://www.netlobo.com/url_query_string_javascript.html
function gup(url, name, win, callback) {
  // const n = name.replace(/[[]/, '[').replace(/[]]/, ']');
  var regexS = '[?&]' + name + '=([^&#]*)';
  var regex = new RegExp(regexS);
  var results = regex.exec(url);

  if (results != null) {
    win.close();
    callback(results[1]);
  }
  return '';
}

function authenticateAgainstServer(code, callback) {
  var url = config.authUrl + '/' + code; // joinPath(config.authUrl, code);
  axios_default.a.get(url, { headers: { 'crossDomain': true } }).then(function (resp) {
    store_legacy_default.a.set('token', resp.data.token);
    callback(resp.data.token, null);
  }).catch(function (e) {
    callback(null, e);
    store_legacy_default.a.clearAll();
  });
}

function getGithubCode(_url, REDIRECT, callback) {
  var win = window.open(_url, 'windowname1', 'width=800, height=600');

  var pollTimer = window.setInterval(function () {
    try {
      if (win.document.URL.indexOf(REDIRECT) !== -1) {
        window.clearInterval(pollTimer);
        var url = win.document.URL;
        gup(url, 'code', win, function (code) {
          authenticateAgainstServer(code, callback);
        });
      }
    } catch (e) {
      // empty
    }
  }, 100);
}

/* harmony default export */ var auth = ({
  login: function login(callback) {
    var url = 'https://github.com/login/oauth/authorize?client_id=' + config.clientId;
    getGithubCode(url, config.redirectUri, callback);
  },
  logout: function logout() {
    store_legacy_default.a.clearAll();
  },
  getToken: function getToken() {
    return store_legacy_default.a.get('token');
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










vue_esm["a" /* default */].use(bootstrap_vue_esm["a" /* default */]);

/* harmony default export */ var App = ({
  name: 'app',
  data: function data() {
    return {
      isAuthenticated: false,
      tables: config.tables,
      userInfo: {
        username: null,
        isAdmin: false
      }
    };
  },

  computed: {
    get_variant: function get_variant() {
      return this.userInfo.isAdmin ? 'dark' : 'info';
    }
  },

  methods: {
    authenticate: function authenticate() {
      var self = this;
      auth.login(function () {
        self.getUserInfo();
      });
    },
    getMembershipInfo: function getMembershipInfo() {
      var _this = this;

      var membershipUrl = 'https://api.github.com/orgs/afqvault/members/' + this.userInfo.username;
      var token = auth.getToken();
      console.log(membershipUrl);
      axios_default.a.get(membershipUrl, { headers: {
          Authorization: 'token ' + token
        }
      }).then(function (resp) {
        if (resp.status === 204) {
          _this.userInfo.isAdmin = true;
        }
      }).catch(function (e) {
        console.log('error', e);
      });
    },
    getUserInfo: function getUserInfo() {
      var token = auth.getToken();
      var self = this;

      // TODO: CHANGE THIS TO YOUR SERVER
      // In this example, we are getting user info from github
      // If this fails, then our token is bad; we are NOT authenticated and
      // should be logged out

      axios_default.a.get('https://api.github.com/user', {
        headers: {
          Authorization: 'token ' + token
        }
      }).then(function (resp) {
        self.isAuthenticated = true;

        // TODO: do stuff here, like setting user info variables
        self.userInfo.username = resp.data.login;
        self.userInfo.avatar = resp.data.avatar_url;
      }).catch(function () {
        self.logout();
      }).then(function () {
        self.getMembershipInfo();
      });
    },
    logout: function logout() {
      this.isAuthenticated = false;
      this.userInfo.username = null;
      this.userInfo.isAdmin = false;
      auth.logout();
    }
  },

  created: function created() {
    this.getUserInfo();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2dc9070","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('b-navbar',{attrs:{"toggleable":"md","type":"dark","variant":_vm.get_variant}},[_c('b-navbar-toggle',{attrs:{"target":"nav_collapse"}}),_vm._v(" "),_c('b-navbar-brand',{attrs:{"href":"#"}},[_vm._v("AFQ-Vault")]),_vm._v(" "),_c('b-collapse',{attrs:{"is-nav":"","id":"nav_collapse"}},[_c('b-navbar-nav',[_c('b-nav-item',{attrs:{"to":"/","exact":""}},[_vm._v("Home")]),_vm._v(" "),_vm._l((_vm.tables),function(table){return _c('span',[_c('b-nav-item',{attrs:{"to":'/tables/'+table}},[_vm._v("\n            "+_vm._s(table)+"\n          ")])],1)})],2),_vm._v(" "),_c('b-navbar-nav',{staticClass:"ml-auto"},[(_vm.isAuthenticated)?_c('b-nav-item-dropdown',{attrs:{"right":""}},[_c('template',{slot:"button-content"},[_c('em',[_vm._v(_vm._s(_vm.userInfo.username))])]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"to":"/profile"}},[_vm._v("Profile")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.logout}},[_vm._v("Signout")])],2):_c('b-nav-item',[_c('a',{on:{"click":function($event){_vm.authenticate()}}},[_vm._v("Admin Login")])])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"router"},[_c('router-view',{attrs:{"isAuthenticated":_vm.isAuthenticated,"userInfo":_vm.userInfo}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("fqxp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Home.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Home = ({
  name: 'Home',
  data: function data() {
    return {
      msg: 'Welcome to your Vue app boilerplate'
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e524fb2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
var Home_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"jumbotron"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"jumbotron-heading"},[_vm._v("AFQ Vault")]),_vm._v(" "),_c('p',{staticClass:"lead text-muted text-center"},[_vm._v(" A vault for AFQ-Browser results\n        "),_c('br'),_c('br'),_vm._v(" "),_c('b-button',{staticStyle:{"color":"white"},attrs:{"variant":"primary","to":"/tables/projects"}},[_vm._v(" View Projects ")])],1),_vm._v(" "),_vm._m(0)])])])])}
var Home_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"desc"},[_c('div',{staticClass:"row"},[_c('p',[_c('a',{attrs:{"href":"https://github.com/yeatmanlab/AFQ"}},[_vm._v("AFQ")]),_vm._v(" (Automated Fiber Quantification) generates tract profiles of tissue properties for major fiber tracts in healthy and diseased brains.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('p',[_c('a',{attrs:{"href":"https://github.com/yeatmanlab/AFQ-Browser"}},[_vm._v("AFQ-Browser")]),_vm._v(" is a visualization tool for AFQ results, and results of other tractometry pipelines including "),_c('a',{attrs:{"href":"https://surfer.nmr.mgh.harvard.edu/fswiki/Tracula"}},[_vm._v("TRACULA")]),_vm._v(".\n          ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('p',[_vm._v("\n            This vault stores the AFQ data shared by researchers. Run "),_c('span',{staticClass:"code"},[_vm._v("afq-browser publish")]),_vm._v(" to share your data on the vault.\n          ")])])])}]
var Home_esExports = { render: Home_render, staticRenderFns: Home_staticRenderFns }
/* harmony default export */ var components_Home = (Home_esExports);
// CONCATENATED MODULE: ./src/components/Home.vue
function Home_injectStyle (ssrContext) {
  __webpack_require__("sMpb")
}
var Home_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Home___vue_template_functional__ = false
/* styles */
var Home___vue_styles__ = Home_injectStyle
/* scopeId */
var Home___vue_scopeId__ = "data-v-3e524fb2"
/* moduleIdentifier (server only) */
var Home___vue_module_identifier__ = null
var Home_Component = Home_normalizeComponent(
  Home,
  components_Home,
  Home___vue_template_functional__,
  Home___vue_styles__,
  Home___vue_scopeId__,
  Home___vue_module_identifier__
)

/* harmony default export */ var src_components_Home = (Home_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Profile.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Profile = ({
  name: 'profile',
  data: function data() {
    return {};
  },

  // the parent component feeds these vars to this component
  props: ['isAuthenticated', 'userInfo']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b1cccd2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile.vue
var Profile_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"profile"}},[(_vm.isAuthenticated)?_c('div',[_c('h1',[_vm._v(_vm._s(_vm.userInfo.username))]),_vm._v(" "),_c('p',[_vm._v("\n      You are logged in. Try logging out to see what happens to this page.\n    ")]),_vm._v(" "),(_vm.userInfo.isAdmin)?_c('p'):_vm._e(),_c('h2',[_vm._v(" You are ADMIN. You can delete stuff ")]),_vm._v(" "),_c('p')]):_c('div',[_c('h1',[_vm._v("Error!")]),_vm._v(" "),_c('p',[_vm._v("\n      Please log in to see your profile\n    ")])])])}
var Profile_staticRenderFns = []
var Profile_esExports = { render: Profile_render, staticRenderFns: Profile_staticRenderFns }
/* harmony default export */ var components_Profile = (Profile_esExports);
// CONCATENATED MODULE: ./src/components/Profile.vue
function Profile_injectStyle (ssrContext) {
  __webpack_require__("Og1M")
}
var Profile_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Profile___vue_template_functional__ = false
/* styles */
var Profile___vue_styles__ = Profile_injectStyle
/* scopeId */
var Profile___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Profile___vue_module_identifier__ = null
var Profile_Component = Profile_normalizeComponent(
  Profile,
  components_Profile,
  Profile___vue_template_functional__,
  Profile___vue_styles__,
  Profile___vue_scopeId__,
  Profile___vue_module_identifier__
)

/* harmony default export */ var src_components_Profile = (Profile_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var object_keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(object_keys);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Tables.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint no-underscore-dangle: ["error", { "allow": ["_items", "_meta", "_id",
                                                "_links", "_showDetails"] }] */




var urljoin = __webpack_require__("mTx5");

/* harmony default export */ var Tables = ({
  name: 'Tables',
  data: function data() {
    return {
      data: null,
      meta: { total: 1, page: 1, max_results: 1 },
      links: null,
      schema: {},
      title: null,
      currentPage: null
    };
  },

  props: ['userInfo', 'isAuthenticated'],
  computed: {
    get_fields: function get_fields() {
      var fields = [];
      var keys = keys_default()(this.schema);
      for (var i = 0; i < keys.length; i += 1) {
        var key = keys[i];
        if (this.schema[key].type === 'string' || this.schema[key].type === 'button') {
          var entry = { key: key, sortable: true };
          fields.push(entry);
        }
      }
      fields.push({ key: 'show_details' });
      return fields;
    },
    get_dict_fields: function get_dict_fields() {
      var fields = [];
      var keys = keys_default()(this.schema);
      for (var i = 0; i < keys.length; i += 1) {
        var key = keys[i];
        if (this.schema[key].type === 'dict') {
          var entry = { key: key, sortable: true };
          fields.push(entry);
        }
      }

      return fields;
    }
  },
  created: function created() {
    this.fetchData();
  },

  watch: {
    $route: 'fetchData'
  },
  methods: {
    fetchData: function fetchData(page) {
      var _this = this;

      var tableName = this.$route.params.id;
      var self = this;
      var url = urljoin(config.url, tableName);

      url = page ? url + '/?page=' + page : url;
      axios_default.a.get(url, { _: Math.random() }).then(function (data) {
        data.data._items.forEach(function (val, idx, arr) {
          var a = arr;
          a[idx]._showDetails = false;
        });
        self.data = data.data._items;
        self.meta = data.data._meta;
        self.links = data.data._links;
        self.schema = config[tableName];
        self.title = _this.$route.params.id;
      });
    },
    do_delete: function do_delete(item) {
      var _this2 = this;

      console.log('item to delete is', item);
      axios_default.a.get('' + config.delete_url + item._id, { _: Math.random() }).then(function (resp) {
        console.log(resp);
        _this2.fetchData();
      }).catch(function (e) {
        console.log('error is', e);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4763c89b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tables.vue
var Tables_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"tables"}},[_c('h1',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('b-pagination',{attrs:{"size":"md","total-rows":_vm.meta.total,"per-page":_vm.meta.max_results,"align":"end"},on:{"change":_vm.fetchData},model:{value:(_vm.meta.page),callback:function ($$v) {_vm.$set(_vm.meta, "page", $$v)},expression:"meta.page"}}),_vm._v(" "),_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.data,"fields":_vm.get_fields,"responsive":"lg"},scopedSlots:_vm._u([{key:"show_details",fn:function(row){return [_c('b-form-checkbox',{model:{value:(row.item._showDetails),callback:function ($$v) {_vm.$set(row.item, "_showDetails", $$v)},expression:"row.item._showDetails"}})]}},{key:"delete",fn:function(row){return [_c('b-button',{attrs:{"variant":"danger","disabled":!_vm.userInfo.isAdmin},on:{"click":function($event){_vm.do_delete(row.item)}}},[_vm._v("x")])]}},{key:"url",fn:function(row){return [_c('a',{attrs:{"href":row.item.url}},[_vm._v(_vm._s(row.item.url))])]}},{key:"row-details",fn:function(row){return [_c('b-card',_vm._l((_vm.get_dict_fields),function(field){return _c('b-row',{staticClass:"mb-2"},[_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"3"}},[_c('b',[_vm._v(_vm._s(field.key))])]),_vm._v(" "),_c('b-col',[_vm._v(_vm._s(row.item[field.key]))])],1)}))]}}])})],1)])])}
var Tables_staticRenderFns = []
var Tables_esExports = { render: Tables_render, staticRenderFns: Tables_staticRenderFns }
/* harmony default export */ var components_Tables = (Tables_esExports);
// CONCATENATED MODULE: ./src/components/Tables.vue
function Tables_injectStyle (ssrContext) {
  __webpack_require__("+R46")
}
var Tables_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Tables___vue_template_functional__ = false
/* styles */
var Tables___vue_styles__ = Tables_injectStyle
/* scopeId */
var Tables___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Tables___vue_module_identifier__ = null
var Tables_Component = Tables_normalizeComponent(
  Tables,
  components_Tables,
  Tables___vue_template_functional__,
  Tables___vue_styles__,
  Tables___vue_scopeId__,
  Tables___vue_module_identifier__
)

/* harmony default export */ var src_components_Tables = (Tables_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js


// import About from '@/components/About';




vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_Home
  },
  /* {
    path: '/about',
    name: 'About',
    component: About,
  }, */
  {
    path: '/profile',
    name: 'Profile',
    component: src_components_Profile
  }, {
    path: '/tables/:id',
    name: 'Tables',
    component: src_components_Tables
  }]
}));
// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  router: router,
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "Og1M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fqxp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sMpb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.1b25c1b4fb0e109940cf.js